import { Col, Row } from 'antd'
import ProductBox from 'components/ProductBox'
import ProductsLoader from 'components/ProductsLoader'
import { StyledSearchResultsWrapper } from '../styles'
import ViewContainer from './container'
import MediumContainer from 'components/MediumContainer'

export default function Index ({ ...pageProps }) {
  return (
    <ViewContainer {...pageProps}>
      {({ results, search, state }) => (
        <MediumContainer>
          <Row justify='center'>
            <Col span={24}>
              <StyledSearchResultsWrapper gutter={[0, 42]}>
                {state.products.status === 1 && (<ProductsLoader count={3} />)}
                {state.products.status === 2 && results.length > 0 && (
                  <>
                    <Col span={24}>
                      <h2>Search Result/s for {search}</h2>
                    </Col>
                  </>
                )}
                {state.products.status === 2 && results.length === 0 && (
                  <Col className='no-result' span={24}>
                    <h3>No Search Result found for</h3>
                    <h3>{search}</h3>
                  </Col>
                )}
              </StyledSearchResultsWrapper>
            </Col>
          </Row>

          {state.products.status === 2 && results.length > 0 && (
            <Row>
              {results.map((product) => (
                <ProductBox key={product.id} product={product.product_data} mode='small' />
              ))}
            </Row>
          )}
        </MediumContainer>
      )}
    </ViewContainer>
  )
}
